export const WORKFLOW_WIDGET_CATALOG_KEY = 'workflow_widget_catalog_v1'

export const DEFAULT_WORKFLOW_WIDGET_CATALOG = {
  workflow_stage_banner: {
    metadata: {
      name: 'Banner de etapa del workflow',
      purpose: 'Comunicar el estado operativo actual del caso',
      description:
        'Widget para mostrar la etapa activa del proceso en lenguaje de negocio, ayudando al equipo a priorizar y entender el avance sin exponer términos técnicos.',
      status: 'Disponible',
      audience: 'Operación y seguimiento',
    },
    resolverKeys: [
      { value: 'workflow.current_stage', label: 'Etapa actual del proceso' },
      {
        value: 'workflow.current_billable_stage',
        label: 'Etapa actual de facturación',
      },
    ],
    modes: [
      { value: 'progress_stage', label: 'Seguimiento de avance' },
      { value: 'billable_stage', label: 'Seguimiento de facturación' },
    ],
    prefixOptions: [
      { value: 'ETAPA', label: 'ETAPA' },
      { value: 'FASE', label: 'FASE' },
      { value: 'ESTADO', label: 'ESTADO' },
    ],
    shapeOptions: [
      { value: 'chevron', label: 'Chevron' },
      { value: 'rounded', label: 'Redondeado' },
      { value: 'flat', label: 'Plano' },
    ],
    emptyStateModes: [
      { value: 'hide', label: 'Ocultar widget' },
      { value: 'message', label: 'Mostrar mensaje' },
    ],
    defaultPreset: 'process_default',
    presets: [
      {
        value: 'process_default',
        label: 'Proceso estándar',
        description:
          'Muestra la etapa actual del proceso con foco operativo general y métrica visible para seguimiento diario.',
        config: {
          resolverKey: 'workflow.current_stage',
          mode: 'progress_stage',
          prefix: 'ETAPA',
          showStageNumber: true,
          showQuotes: false,
          shape: 'rounded',
          emptyStateMode: 'message',
          customLabel: '',
          showMetrics: true,
        },
      },
      {
        value: 'billing_focus',
        label: 'Foco en facturación',
        description:
          'Prioriza la etapa de facturación para equipos que necesitan validar rápidamente si un caso está listo para cobro.',
        config: {
          resolverKey: 'workflow.current_billable_stage',
          mode: 'billable_stage',
          prefix: 'ETAPA',
          showStageNumber: true,
          showQuotes: false,
          shape: 'rounded',
          emptyStateMode: 'message',
          customLabel: 'Etapa facturable',
          showMetrics: false,
        },
      },
    ],
  },
}

export const readWorkflowWidgetCatalog = () => {
  try {
    const raw = localStorage.getItem(WORKFLOW_WIDGET_CATALOG_KEY)
    if (!raw) return DEFAULT_WORKFLOW_WIDGET_CATALOG
    const parsed = JSON.parse(raw)
    if (!parsed || typeof parsed !== 'object') {
      return DEFAULT_WORKFLOW_WIDGET_CATALOG
    }
    return parsed
  } catch {
    return DEFAULT_WORKFLOW_WIDGET_CATALOG
  }
}

export const saveWorkflowWidgetCatalog = (catalog) => {
  localStorage.setItem(WORKFLOW_WIDGET_CATALOG_KEY, JSON.stringify(catalog))
}

export const resetWorkflowWidgetCatalog = () => {
  localStorage.removeItem(WORKFLOW_WIDGET_CATALOG_KEY)
}
